let contactStorage = require('./storage.js');
let contactLanguage = require('./locale/language.js');
const utils = require('./utils.js');
let storage = require("./storage.js");
let stropheConnection = require("./stropheConnection.js");
let groups = require("./groups.js");
let anchorme = require("anchorme").default;
let broadcastProfilePage = require('./broadcastProfile.js')
let contact = require("./contact.js");
let language = require("./locale/language.js");
const webEncrypt  = require('./webchatEncryptDecrypt.js');
const recent = require('./recent.js');

let totalFwdRecords
let shouldHandleScroll,msgcontent;


module.exports = {

    getRecentFwdContacts: function(recentFwdQueryParam,page){
        let mainUrl = window._env_.ApiURL + "/users/chat/recent";
        let url = mainUrl + recentFwdQueryParam;

        
        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            async: false,
            crossDomain: true,
            headers: {
                'authorization': contactStorage.getuserToken()
            },
            statusCode: {
                401: function (response) {
                    console.log('Security Token Error');
                    let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
                    let username = loginUserInfo[0][0];
                    contactStorage.setSession(username)
                    module.exports.getRecentFwdContacts(conQueryParams)
                },
                500: function (response) {
                    console.log('Internal Server Error');
                }
            },
            success: function (response) {
                let data = response.data;
                totalFwdRecords = response.totalRecords
                module.exports.enableScrollHandler();
                module.exports.getRecentFwdContactsCallback(data,page)
                module.exports.recentForwardContactsSelected();
            },
            error: function (jqXHR, exception) {
                utils.errorMsgHandling(jqXHR, exception)

            },
            complete: function(){
                $(".sideContactNavLoader").hide()
                $(".sideParticipantNavLoader").hide()
                $(".sideBroadcastParticipantNavLoader").hide()
                $(".sideBroadcastContactListNavLoader").hide()
                $(".sideContactListNavLoader").hide()
                $(".sideTeamContactListNavLoader").hide()
            }
        });
    },


    getRecentFwdContactsCallback: function (recentChatData,page) {
        try{

          webEncrypt.deleteItemFromLocalStorage('usersPriorityInfo');
        $(".loader").css("display", "none");
 
          if (typeof recentChatData !== 'undefined' && recentChatData.length > 0) {
            module.exports.recentFwdContactFirstPageHandling(page);
           
            module.exports.recentFwdContactForLoopHandling(recentChatData)

           
          }else {
            $("#recent-contact .recentchatcontact").children().remove()
            $("#recent-contact .recentchatcontact").html("<div id='noFwdcontent'>No recent chat available</div>");
          }
          
      } catch (err) {
        console.log("Forward Recent chat callback Handler", err);
      }
        return true;
      },
      recentFwdContactFirstPageHandling: function(page) {
          if(page == 1){
            $("#recent-contact .recentchatcontact").children().remove()
          }
      },

      recentFwdContactForLoopHandling: function(recentChatData) {
        let mediaUrl = window._env_.ApiURL + "/media/";

        let userToken = storage.getuserToken();
        let userJID = stropheConnection.logininfo.userJID.toLowerCase();
              
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');


        for (let keys in recentChatData) {
          let recentChat  = recentChatData[keys];

          let msgfrom             = recentChat.fromUser;
          let status              = recentChat.status;
          let msgid               = recentChat.messageId;
          let msgto               = recentChat.toUser;
          let chattype            = recentChat.chatType;
          let name,tempname,profileimage,image,messageid;
          let userAndGrpIds = [];
          tempname = module.exports.getRecentFwdTempName(msgfrom,msgto,userJID)
          if(chattype != 'broadcast'){
            userAndGrpIds.push(msgfrom)
          }

          if (groupInfo != null && typeof groupInfo[tempname] != "undefined") {
            profileimage = groupInfo[tempname][2];

            image = module.exports.getRecentFwdGrpInfoImg(profileimage,userToken,mediaUrl)
    
            name = groupInfo[tempname][1];
            messageid = msgid;
          } else if (userInfo != null && typeof userInfo[tempname] != "undefined") {

            profileimage = userInfo[tempname][2];

            image = module.exports.getRecentFwdUserInfoImg(profileimage,userToken,mediaUrl)

            name = userInfo[tempname][1];
            messageid = msgid;
          } else if (broadcastProfile != null && typeof broadcastProfile[tempname] != "undefined") {
            profileimage = broadcastProfile[tempname][2];

            image = module.exports.getRecentFwdBroadcastInfoImg(profileimage,userToken,mediaUrl)
           
            name = broadcastProfile[tempname][1];
            messageid = msgid;
          } else if (tempname != userJID) {
    
            image = module.exports.getRecentFwdRecentOtherUserImg(chattype,userInfo,tempname)

            name = tempname;
            messageid = msgid;
    
          }

          msgcontent = module.exports.getRecentFwdMsgContent(recentChat,tempname,messageid,name);

          if (status == 4) {
            msgcontent = "";
            messageid = "";
          }

          msgcontent = module.exports.getRecentFwdMsgContentForBlockedUser(tempname,msgcontent);

          msgcontent = module.exports.getRecentFwdMsgContentForDeletedUser(recentChat,msgcontent);
       
          module.exports.getRecentFwdMsgRecentChatObj(recentChat,msgcontent,tempname,name,image,userAndGrpIds)
     
        }

      },
      getRecentFwdTempName: function(msgfrom,msgto,userJID) {
        let tempname;
        if (msgfrom == userJID) {
          tempname = msgto.toLowerCase();
        } else {
          tempname = msgfrom.toLowerCase();
        }
        
        return tempname;
      },

      getRecentFwdGrpInfoImg: function(profileimage,userToken,mediaUrl) {
        let image;
        if (utils.getHexRegexPattern().test(profileimage)) {
          image = profileimage;
        } else if (profileimage !== "src/images/avatar/group/group_four.svg" && profileimage.trim() !== "") {
          image = mediaUrl + profileimage + "?mf=" + userToken;
        } else if (profileimage.trim() == "") {
          image = "src/images/avatar/group/group_four.svg";
        } else {
          image = profileimage;
        }

        return image;
      },

      getRecentFwdUserInfoImg: function(profileimage,userToken,mediaUrl) {
        let image;
        if (utils.getHexRegexPattern().test(profileimage)) {
          image = profileimage;
        } else if (typeof profileimage != 'undefined' && profileimage !== "src/images/avatar/chat/profile_img_one.svg" && profileimage.trim() !== "") {
          image = mediaUrl + profileimage + "?mf=" + userToken;
        } else if (typeof profileimage === 'undefined' || profileimage.trim() == "") {
          image = "src/images/avatar/chat/profile_img_one.svg";
        } else {
          image = profileimage;
        }

        return image;
      },
      getRecentFwdBroadcastInfoImg: function(profileimage,userToken,mediaUrl) {
        let image;
        if (profileimage !== "src/images/avatar/broadcast/profile_img_one.png" && profileimage.trim() !== "") {
          image = mediaUrl + profileimage + "?mf=" + userToken;
        } else if (profileimage.trim() == "") {
          image = "src/images/avatar/broadcast/profile_img_one.png";
        } else {
          image = profileimage;
        }

        return image;
      },

      getRecentFwdRecentOtherUserImg: function(chattype,userInfo,tempname) {
        let image;
        if (chattype == "chat") {
          if (userInfo == null) {
            userInfo = {};
          }
          userInfo[tempname] = [];
          userInfo[tempname].push("chat");
          userInfo[tempname].push(tempname);
          userInfo[tempname].push("src/images/avatar/chat/profile_img_one.svg");
          userInfo[tempname].push(language.locali().default_status);
          webEncrypt.encryptAndStoreInLocalStorage('usersProfileInfo', userInfo)
          image = "src/images/avatar/chat/profile_img_one.svg";
          userprofile.getUserProfile(tempname);
          vCard.getVcard(tempname + "@" + stropheConnection.Server());
      
        } else {
            groups.getGroup(tempname);
        }

        return image;
      },

      getRecentFwdMsgContent : function(recentChat,tempname,messageid,name) {

          let msgid               = recentChat.messageId;
          let messageType         = recentChat.messageType;

        if (msgid == 0 || messageType == 'notification') {
          msgcontent = module.exports.handleRecentFwdMsgContentNotification(recentChat)
          
        } else {
          msgcontent = module.exports.handleRecentFwdMsgContentForBroadcast(recentChat)
         
          msgcontent = module.exports.handleRecentFwdMsgContentForOtherChat(recentChat,tempname,messageid,msgcontent)
          

        }

        return msgcontent;
      },

      getRecentFwdMsgContentForBlockedUser: function(tempname,msgcontent) {

        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let blockListUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('blockListUserInfo');
        let blockUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('blockUserInfo');
        
        let image;

        if (blockListUserInfo != null && typeof blockListUserInfo[tempname] != "undefined") {
          image = "src/images/avatar/chat/profile_img_one.svg";
          if (userInfo != null && typeof userInfo[tempname] != "undefined") {
            userInfo[tempname][2] = image;
            userInfo[tempname][3] = language.locali().default_status;
            webEncrypt.encryptAndStoreInLocalStorage('usersProfileInfo', userInfo)
          }
        }

        if (blockUserInfo != null && typeof blockUserInfo[tempname] != "undefined") {
          msgcontent = "";
        }

        return msgcontent;
      },

      getRecentFwdMsgContentForDeletedUser: function(recentChat,msgcontent) {
        let msgto               = recentChat.toUser;
        let deletedstatus       = '';
        let deletedby           = '';
        let blockedby           = '';

        if ((deletedstatus == 1 && deletedby == userJID) || blockedby == msgto || deletedstatus == 2 ) {
          msgcontent = "";
        }

        return msgcontent;
      },

      getRecentFwdMsgRecentChatObj: function(recentChat,msgcontent,tempname,name,image,userAndGrpIds) {

        let userJID = stropheConnection.logininfo.userJID.toLowerCase();

        let msgto               = recentChat.toUser;
        let chatdeletedstatus   = '';
        let chatdeletedby       = '';
        let blockedby           = '';


        if ((chatdeletedstatus == 1 && chatdeletedby == userJID) || blockedby == msgto || chatdeletedstatus == 2 ) {
          //deleted chat
        } else {
          let recentChatObj = {
            nodeJid       :tempname,
            name          :name,
            image         :image,
            msgcontent    :msgcontent,
            
          }

          module.exports.fwdRecentChatContent(recentChatObj);
          utils.commonHeaderTitleUpdate()
          
        }

         if(userAndGrpIds.length > 0){
            userAndGrpIds = userAndGrpIds.join(',');
            recent.getRecentPriorityMsgCount(userAndGrpIds)
          }

      },

      handleRecentFwdMsgContentNotification: function(recentChat){

        let usersPriorityInfo = {};
        let userJID = stropheConnection.logininfo.userJID.toLowerCase();
        let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

        let msgfrom             = recentChat.fromUser;
        let status              = recentChat.status;
        let msgbody             = recentChat.txt;
        let chattype            = recentChat.chatType;
        let msgConvFrom         = recentChat.messageFrom;
        let msgConvTo           = recentChat.messageTo;
        let notificationTo      = recentChat.notificationTo;
        let messageFromId       = recentChat.messageFromId;
        let priorityCount       = 0;
        let noAckPriorityCount  = 0;

        let msgcontent;
        if (chattype == "chat" || chattype == "broadcast") {
          if (broadcastProfile != null && typeof broadcastProfile[msgfrom] != "undefined") {
            msgcontent = utils.broadcastNotificationLablestatus(msgbody, msgConvTo);

  
          } else {
            msgcontent = "";
          }

        } else if (chattype == "normal") {
          msgcontent = utils.groupstatus(msgfrom, messageFromId, notificationTo, msgbody, msgConvFrom, msgConvTo);
          if(priorityCount > 0 || noAckPriorityCount > 0) {
            usersPriorityInfo[tempname] = [];
            usersPriorityInfo[tempname][0] = parseInt(noAckPriorityCount);
            usersPriorityInfo[tempname][1] = parseInt(priorityCount);
            if(msgbody == 3 && status == userJID) {
              // user removed from the group
            } else {
              msgcontent = '<span class="priority-message-recent">PRIORITY</span>' + msgcontent;
            } 
          }
        }

        return msgcontent;
      },

      handleRecentFwdMsgContentForBroadcast : function (recentChat) {
        let usersPriorityInfo = {};

        let botType             = recentChat.chatType;
        let msgid               = recentChat.messageId;
        let msgbody             = recentChat.txt;
        let messageType         = recentChat.messageType;
        let priorityCount       = 0;
        let noAckPriorityCount  = 0;

        let msgcontent = "";
        if (botType == "chat" || botType == "broadcast") {
         try {
           
           let decryptedMsg = utils.decrypt(msgbody, msgid);
           let msgContent = module.exports.getFwdDecryptedMsgContent(decryptedMsg);
           let messageBodyContent;
           if(priorityCount > 0 || noAckPriorityCount > 0) {
             usersPriorityInfo[tempname] = [];
             usersPriorityInfo[tempname][0] = parseInt(noAckPriorityCount);
             usersPriorityInfo[tempname][1] = parseInt(priorityCount);
             messageBodyContent = utils.checkMessageType(msgContent, msgid, 2);
           } else {
             messageBodyContent = utils.checkMessageType(msgContent, msgid);
           }
           msgcontent = messageBodyContent[0];
         }catch (err){
           console.log(err);
           msgcontent = "";
         }
        } else {
          try {
            
            let decryptedMsg = utils.decrypt(msgbody, msgid);
            let msgContent = module.exports.getFwdDecryptedMsgContent(decryptedMsg);
            let msgIcon = recent.getGroupChatRecentIcon(messageType);
            
            msgbody = module.exports.getFwdDecryptedMsgBody(msgContent,messageType)
            msgcontent = msgIcon + anchorme(minEmoji(msgbody), {
              attributes: [
                function (urlObj) {
                  if (urlObj.protocol !== "mailto:")
                    return { name: "target", value: "blank" };
                }
              ]
            }) ;
          } catch (err){
            console.log(err);
            msgcontent = "";
          }
        }

        return msgcontent;
      },
      getFwdDecryptedMsgContent : function(decryptedMsg) {
        let msgContent = (decryptedMsg && decryptedMsg != '') ? JSON.parse(decryptedMsg) : '';

        return msgContent;

      },
      getFwdDecryptedMsgBody: function(msgContent,messageType) {
        let msgbody = (msgContent) ? msgContent.message : '';

        switch (messageType) {
          case 'video':
              msgbody = "Video";
              break;
          case 'audio':
              msgbody = "Audio";
              break;
          case 'image':
              msgbody = "Photo";
              break;
          case 'file':
              msgbody = "File";
              break;
          case 'contact':
              msgbody = "Contact";
              break;
          case 'location':
              msgbody = "Location";
              break;
          default:
              break;
      }
    

        return msgbody;
      },

      handleRecentFwdMsgContentForOtherChat: function(recentChat,tempname,messageid,msgcontent) {
        
        let chattype            = recentChat.chatType;

        if (chattype == "chat") {
          msgcontent = module.exports.getRecentFwdChatMsgContent(recentChat,tempname,messageid,msgcontent)
          
        } else if (chattype == "normal") {
          msgcontent = module.exports.getRecentFwdGroupMsgContent(recentChat,tempname,messageid,msgcontent)

        } else if (chattype == "broadcast") {
          msgcontent = module.exports.getRecentFwdBroadcastMsgContent(recentChat,tempname,messageid,msgcontent)

         
        } 
        return msgcontent;
      },

      getRecentFwdChatMsgContent: function(recentChat,tempname,messageid,msgcontent) {

        let userJID = stropheConnection.logininfo.userJID.toLowerCase();
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let recallstatus        = recentChat.recallStatus;
        let messageFromId       = recentChat.messageFromId;
  
        let priorityCount       = 0;
        let noAckPriorityCount  = 0;

        if ((userInfo != null && typeof userInfo[tempname] != "undefined")) {

          if (messageFromId == userJID) {
            msgcontent = module.exports.getRecentFwdMsgPriorityContentFirst(recallstatus,priorityCount,noAckPriorityCount,msgcontent)
           
          } else {
            msgcontent = module.exports.getRecentFwdMsgPriorityContentSecond(recallstatus,priorityCount,noAckPriorityCount,msgcontent)
            
          }
        }
        return msgcontent;
      },
      getRecentFwdMsgPriorityContentFirst: function(recallstatus,priorityCount,noAckPriorityCount,msgcontent) {
        if (recallstatus == 1) {
          if(priorityCount > 0 || noAckPriorityCount > 0) {
            msgcontent = "<i class='text-italic icon-name-status'><span class='priority-message-recent'>PRIORITY</span> <span class='inner-msg-txt'>You deleted this message</span></i>";
          } else {
            msgcontent = "<span class='inner-msg-txt'>You deleted this message</span>";
          }
        } 

        return msgcontent;
      },

      getRecentFwdMsgPriorityContentSecond: function(recallstatus,priorityCount,noAckPriorityCount,msgcontent){
        if (recallstatus == 1 && msgcontent != "") {
          if(priorityCount > 0 || noAckPriorityCount > 0) {
            msgcontent = "<i class='text-italic icon-name-status'><span class='priority-message-recent'>PRIORITY</span> <span class='inner-msg-txt'>This message was deleted</span></i>";
          } else {
            msgcontent = "<span class='inner-msg-txt'>This message was deleted</span>";
          }
        }

        return msgcontent;
      },

      getRecentFwdGroupMsgContent: function(recentChat,tempname,messageid,msgcontent) {
        let userJID = stropheConnection.logininfo.userJID.toLowerCase();
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')

        let publisher           = recentChat.fromUser;
        let recallstatus        = recentChat.recallStatus;
        let priorityCount       = 0;
        let noAckPriorityCount  = 0;
        if (groupInfo != null && typeof groupInfo[tempname] != "undefined") {

          if(publisher == userJID) {
            msgcontent = module.exports.getRecentFwdMsgPriorityContentFirst(recallstatus,priorityCount,noAckPriorityCount,msgcontent);
           
          } else {
            msgcontent = module.exports.getRecentFwdMsgPriorityContentSecond(recallstatus,priorityCount,noAckPriorityCount,msgcontent)

            
          }
          utils.getGroupMsginfo(messageid, tempname + "@mix." + stropheConnection.Server());
        } 

        return msgcontent;
      },
      getRecentFwdBroadcastMsgContent: function(recentChat,tempname,messageid,msgcontent){
        let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');

        let msgfrom             = recentChat.fromUser;
        let status              = recentChat.status;
        let recallstatus        = recentChat.recallStatus;
        let broadcastmsg_id     = recentChat.broadcastMsgId;
  
        let priorityCount       = 0;
        let noAckPriorityCount  = 0;

        if (msgfrom != "") {
          if (broadcastProfile != null && typeof broadcastProfile[msgfrom] != "undefined") {

            msgcontent = module.exports.getRecentFwdMsgPriorityContentFirst(recallstatus,priorityCount,noAckPriorityCount,msgcontent)
          
            if (status != 4) {

              let id = utils.randomString(16, 'a#');
              broadcastProfilePage.getBroadcastMsginfo(broadcastmsg_id,stropheConnection.Server(),id);
            }

          }
        }
        return msgcontent;
      },
      fwdRecentChatContent: function (recentChatObj,addElType) {
        let nodeJid = recentChatObj.nodeJid;
        let name = recentChatObj.name;
        let image = recentChatObj.image;
        let msgcontent = recentChatObj.msgcontent;
        let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
        let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
        let imgDiv;
    
        if (typeof name != "undefined") {
    
          let Icon ='';
          if(userInfo != null && typeof userInfo[nodeJid] != "undefined" && userInfo[nodeJid][7] == "1") {
            image = userInfo[nodeJid][2];
            Icon = module.exports.handleRecentChatUserInfo(userInfo,nodeJid,image);
          }
    
          if(typeof image != 'undefined' && ( utils.getHexRegexPattern().test(image) || image.startsWith("#") )) {
            Icon = module.exports.handleRecentChatGroupInfo(groupInfo,nodeJid,image);
            let imageColor = utils.hexToRgbA(image);
           
            imgDiv = '<div class="color-code-recent" id="color-'+nodeJid+'" style="display: block; background:'+imageColor+'">'+Icon+'</div>';
          } else {
            let concatedLetter,imageElment;

            concatedLetter = module.exports.getFwdRecentChatConcatLetter(name);
            
            imageElment = module.exports.getFwdRecentChatImgElement(image,nodeJid,concatedLetter);
    
            imgDiv = imageElment;
          }
       
          
          let favIcon         = recentChatObj.isChatUser == 1 ? '<img class="fave_icone" src="./src/images/svg/ikonixicon.svg">' : '';
          let contactDiv = '<div class="recentchatfwdcontent contactfwdcontent contact-list sideBar-body" id="forwardcontact-' + nodeJid + '"><div class="select-cnt-blk"><input type="checkbox" class="select-message3" name="' + name + '" value="' + nodeJid + '" id="' + nodeJid + '"><label></label></div><div class="col-sm-3 col-xs-3 sideBar-avatar">';
          let imageDiv        = '<div class="avatar-icon">'+imgDiv+favIcon+'</div></div>';
          let nameDiv         = '<div class="col-sm-9 col-xs-9 sideBar-main recentGroupNameDiv"><div class="row"><div class="col-sm-12 col-xs-12  sideBar-name"><span class="name-meta">' + minEmoji(name) + '</span><span class="name-status fwdMsgSpan"><span class="name-status text-italic"><i class="text-italic icon-wrapper">' + minEmoji(msgcontent) + '</i></span></span></div></div></div>';


          let nameDivFwd = nameDiv + '</div></div>';
    
          let unregisteredUser = userInfo[nodeJid] ? userInfo[nodeJid][16] : '';
          module.exports.handleFwdRecentChatUnregister(unregisteredUser,userInfo,nodeJid);
          

          $("#recent-contact .recentchatcontact").append(contactDiv + imageDiv + nameDivFwd );
    
        }
      },
      getFwdRecentChatConcatLetter: function(name) {
        let concatedLetter;
        if(name != "") {
          concatedLetter = utils.getImageDisplayText(name);
        }
        return concatedLetter;
      },
      getFwdRecentChatImgElement : function(image,nodeJid,concatedLetter) {
        let imageElment;
        if(typeof image !='undefined' && (image !== 'src/images/avatar/chat/profile_img_one.svg' && image.trim() !== '')){
                
            imageElment ='<img id="recentContactImg-'+nodeJid+'" class="other-prof-pic recentChatLazy" data-src="' + image + '" onerror="' + module.exports.profileImgError() + '" data-text="'+concatedLetter+'" onerror="' + contact.profileImgError() + '" src="'+image+'">';
        }  else {
            imageElment = '<svg id ="recentContactImg-'+nodeJid+'" class="avatar-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scale(1.25);"><circle fill="#CCC" cx="50" cy="50" r="50"></circle><text dominant-baseline="central" fill="rgba(255,255,255,1)" font-size="30pt" text-anchor="middle" x="50" y="50" style="font-weight:700">'+concatedLetter+'</text></svg>';

        }

        return imageElment;

      },
      handleRecentChatUserInfo : function(userInfo,nodeJid,image){
        let Icon;
        if(typeof image != 'undefined' && ( utils.getHexRegexPattern().test(image) || image.startsWith("#"))) {
          let onCallIcon = userInfo[nodeJid][14];
          let onCallForegroundColor = userInfo[nodeJid][15].trim();
          let fillColor = utils.getSpecialGroupForegroundColor(onCallForegroundColor);
          let onCallImage = image;
          Icon = utils.getOncallIcon(onCallIcon, fillColor, onCallImage);
        }else {
          Icon = ''; 
        }

        return Icon;
      },
      handleRecentChatGroupInfo: function(groupInfo,nodeJid,image) {
        let Icon;
        if(groupInfo != null && typeof groupInfo[nodeJid] != "undefined"){
          let onCallIcon = groupInfo[nodeJid][7];
          let onCallForegroundColor = groupInfo[nodeJid][8].trim();
          let fillColor = utils.getSpecialGroupForegroundColor(onCallForegroundColor);
          let onCallImage = image;
          Icon = utils.getOncallIcon(onCallIcon, fillColor, onCallImage);
        }else {
          Icon = '';
        }
        return Icon;
      },
      handleFwdRecentChatUnregister : function (unregisteredUser,userInfo,nodeJid) {

        if (userInfo != null && typeof userInfo[nodeJid] != 'undefined' && unregisteredUser == 1) {
          return true
        }

      },
      profileImgError: function() {
        $('img').on("error", function () {
          this.onerror = "";
          this.src = "./src/images/avatar/chat/profile_img_one.svg";
        });
      },

         /** Function to disable the event handler **/
   disableScrollHandler:function() {
    shouldHandleScroll = false;
  },

  /** Function to enable the event handler **/
  enableScrollHandler:function() {
      shouldHandleScroll = true;
  },
  recentForwardContactsSelected: function(){
    let selecteduserInfo = webEncrypt.getFromLocalStorageAndDecrypt('selecteduserInfo');
    if (selecteduserInfo != null) {
        for(let key in selecteduserInfo) {
            $(".recentchatcontact .recentchatfwdcontent").find("input[type=checkbox][value=" + selecteduserInfo[key][0] + "]").prop("checked", true);
        }
    }
  },
  isScrollAtBottom: function(elementId) {
    let element = document.getElementById(elementId); // Replace with the ID of your element
    let scrollPosition = element.scrollTop;
    
    let scrollableHeight = element.scrollHeight - element.clientHeight;
    
    let threshold = 10;
    return scrollableHeight - scrollPosition <= threshold;
  }

}


$('#recent-contact').on('scroll', function () {
    let isScroll = module.exports.isScrollAtBottom('recent-contact');
   

    if (isScroll) {
        
        let search =  $("#forwardText").val().trim();
        let contactfwd = $('.recentchatcontact .contactfwdcontent').length;
        let contactfwdLength = parseInt(contactfwd) / contactLanguage.locali().default_recent_chat_pagination;
        let page = Math.round(contactfwdLength) + 1;

        let recentFwdQueryParam = '?page=' + page + '&size=' + contactLanguage.locali().default_recent_chat_pagination + '&search=' + search+ '&forForwarding=' + true;

        if(totalFwdRecords == contactfwd){
          
          module.exports.disableScrollHandler();
        }
        if (!shouldHandleScroll) {// Skip Or Stop Scroll event After Reach Last Element
          return; // Skip handling the event if the flag is false
        }
        if (contactfwd % contactLanguage.locali().default_recent_chat_pagination == 0) {
            module.exports.getRecentFwdContacts(recentFwdQueryParam,page);
        }

        
    }
});


